import { Time } from '@carsys/enums/time'
import useGetPlannedDurationSettings from 'app/settings/components/PlannedDurationSettings/use-get-planned-duration-settings'

const tenMinutes = 10 * Time.Minute

export const useSettings = () => {
  // For now we reuse the hooks that are built in the settings locations themselves, but once we start adding more settings calls in here,
  // we need to think of a way to refactor it in such a way that we don't have multiple random query keys that need to be invalidated.
  return useGetPlannedDurationSettings({ cacheTime: tenMinutes, staleTime: tenMinutes, refetchInterval: tenMinutes })
}
